import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

import { version } from "../../../package.json";

const state = {
  version: version,
  backendServer: "https://dev-api.safetyplanner.de/api/v1/",
  turnstileSiteKey: ["localhost", "127.0.0.1"].includes(
    window.location.hostname,
  )
    ? "1x00000000000000000000AA"
    : "0x4AAAAAAENET4tLX2xC3hkD",
  registrationEnabled: true,
  error: {
    visible: false,
    message: null,
  },
  snackbar: {
    visible: false,
    message: null,
  },
  universalAlert: {
    visible: false,
    text: null,
    heading: null,
    type: null,
  },
};

const configModule = {
  state,
  mutations,
  actions,
  getters,
};

export default configModule;
